import { SystemFieldNames, SystemFieldGroups, getTreatmentGroupsTitle, getTreatmentGroupsDescription, INDEPENDENT_VARIABLES } from './systemFieldConstants'
import { fieldDetails as irrigationTypeControlGroup } from './irrigationTypeControlGroup'

import type { QField } from '~/features/questionnaire/types'
import type { SystemFieldDetails } from './systemFieldConstants'

const
  independentVariable = INDEPENDENT_VARIABLES.IRRIGATION_TYPE,
  schemaEntry: QField = {
    fieldName: SystemFieldNames.irrigationTypeTreatmentGroups,
    fieldType: 'COLLECTION',
    visibleWhen: irrigationTypeControlGroup.schemaEntry.visibleWhen,
    format: irrigationTypeControlGroup.schemaEntry.format
  },
  fieldDetails: SystemFieldDetails = {
    fieldName: SystemFieldNames.irrigationTypeTreatmentGroups,
    variableGroup: SystemFieldGroups.EXP_DESIGN,
    isRequired: true,
    title: getTreatmentGroupsTitle(independentVariable),
    description: getTreatmentGroupsDescription(independentVariable),
    treatmentGroupsFor: independentVariable,
    schemaEntry
  }

export {
  fieldDetails
}
